<template>
  <b-btn :class="['brb-btn']" v-bind="attrs" v-on="$listeners">
    <div class="d-flex align-items-center justify-content-center">
      <div class="w-100" :style="`opacity: ${loading ? 0 : 1}`">
        <slot></slot>
      </div>

      <b-spinner
        v-if="loading"
        class="position-absolute"
        v-bind="loadingProps"
      />
    </div>
  </b-btn>
</template>

<script>
export default {
  name: 'BrbBtn',
  inheritAttrs: false,
  props: {
    loading: Boolean,
    loadingProps: {
      type: Object,
      default: () => {
        return {
          small: true
        }
      }
    }
  },
  computed: {
    attrs() {
      const attrs = { ...this.$attrs }

      attrs.disabled = this.loading || attrs.disabled || false

      return attrs
    }
  }
}
</script>

<style lang="scss">
@import '~/src/assets/scss/components/brb-components/brb-btn';
</style>
